import React from 'react';

import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';
import SearchField from '../SearchField';
import SearchIcon from '@material-ui/icons/Search';

import styles from './styles';
import { IconButton } from '@material-ui/core';
const useStyles = makeStyles(styles);

function CardHolder({ color, title, labelName, disableBtnOptions, labelSearch, ...props }) {
  const classes = useStyles();

  return (
    <Paper className={classes.container} elevation={3}>
      <Toolbar className={[classes.header, color].join(' ')}>
        <h3 className={classes.title}>{title}</h3>
        {props.handleOpenDrawer && (
          <Button
            variant="contained"
            size="small"
            type="submit"
            className={classes.search}
            onClick={props.handleOpenDrawer}
            disableElevation
          >
            <Search /> Nova Busca
          </Button>
        )}
        {props.handleSearch && (
          <div className={classes.searchField}>
            <SearchField onSearch={props.handleSearch} placeholder={labelSearch} />
          </div>
        )}
        <div>
          {props.handleOptions && (
            <Button
              variant="contained"
              type="submit"
              color="primary"
              className={classes.button}
              onClick={props.handleOptions}
              disabled={disableBtnOptions}
              disableElevation
            >
              {labelName}
            </Button>
          )}
          {props.handleFilter && (
            <>
              <IconButton
                aria-label="filter"
                onClick={() => props.handleFilter()}
                className={classes.searchButton}
              >
                <SearchIcon />
              </IconButton>
            </>
          )}
        </div>
      </Toolbar>
      <div className={classes.content}>{props.children}</div>
    </Paper>
  );
}

export default CardHolder;
